import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) { navigate("/login"); return; }
      const sessionId = decodeURIComponent(match[1]);
      try {
        const roleIntent = localStorage.getItem("cs_role_intent") || undefined;
        const { data } = await api.post("/auth/session", { session_id: sessionId, role: roleIntent });
        localStorage.removeItem("cs_role_intent");
        if (data?.token) localStorage.setItem("cs_token", data.token);
        window.history.replaceState(null, "", window.location.pathname);
        const u = await refresh();
        if (u?.role === "parent") navigate("/parent");
        else navigate(u?.club_id ? "/app" : "/onboarding");
      } catch (e) {
        setErr("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1500);
      }
    };
    run();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="h-10 w-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">{err || "Signing you in..."}</p>
      </div>
    </div>
  );
}
